export default __webpack_public_path__ + "static/background-6-9ec30596329038a7931b2bfc9eb75f16.png";